<template>
  <div
    :class="[
      'bottom-wrapper',
      {
        'is-fixed': !isEditorStatus,
        'no-img': !property_data.image_url,
      },
    ]"
    :style="{
      paddingLeft: property_data.margin + 'px',
      paddingRight: property_data.margin + 'px',
      bottom: property_data.distance + 'px',
      paddingBottom: isEditorStatus ? property_data.distance + 'px' : 0,
    }"
  >
    <img
      ref="bottomImg"
      @click="jump(config.link_data[0].link_data)"
      v-if="property_data.image_url"
      class="bottom-img"
      :src="property_data.image_url"
      :style="{
        borderRadius: property_data.radius + 'px',
      }"
      alt="bottom"
    />
    <img
      v-else
      class="bottom-no-img"
      src="https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png"
      alt="no"
    />
  </div>
</template>


<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-bottom-float",
  props: ["config", "isEditorStatus"],
  computed: {
    property_data() {
      return {
        ...this.config.property_data,
        ...this.config.link_data[0],
      };
    },
  },
  watch: {
    "property_data.image_url": {
      handler: function (val) {
        const that = this;
        const distance = +this.property_data.distance;
        if (val) {
          this.$nextTick(() => {
            const bottomImg = document.querySelector(".bottom-img");
            // getBoundingClientRect().height 或 其他什么方法 获取高度不准确，由于图片高度被设置 auto, 需要在图片加载之后获取，
            bottomImg &&
              (bottomImg.onload = function () {
                that.config.property_data.paddingBottom =
                  bottomImg.height + distance + 10;
              });
          });
        } else {
          this.$nextTick(() => {
            const bottomImg = document.querySelector(".bottom-no-img");
            bottomImg &&
              (bottomImg.onload = function () {
                that.config.property_data.paddingBottom =
                  bottomImg.height + distance + 10;
                console.log("xxxx", that.config.property_data.paddingBottom);
              });
          });
        }
      },
      immediate: true,
    },
  },
  components: {},
  methods: {
    jump(item) {
      if (this.isEditorStatus || !item) {
        return;
      }
      redirectURL(item.toString(), "seller");
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>